import React from "react";
import styled from "styled-components";
import ItemsTab from "../../../components/itemstab";

import { MdNotifications } from "react-icons/md";
import GoBack from "../../../components/GoBack";
import { useFindAllUsersByIdQuery } from "../../../generated/graphql";
import Empty from "../../../components/Empty";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const Div = styled.div`
  position: relative;
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;

  h6 {
    font-size: 0.875rem;
  }

  p {
    font-size: 1rem;
  }

  .font-medium {
    font-size: 0.875rem;
  }

  h1 {
    color: #4285f4;
  }
`;

const MinorProfile = () => {
  const user = useSelector((state: RootState) => state.loggedInUser.data);
  const { data, loading, error } = useFindAllUsersByIdQuery({
    variables: { input: user?.id },
  });

  if (loading) <div>Loading...</div>;
  if (error) <Empty text={error.message} />;
  if (!data?.findAllUsersById) return null;
  if (Array.isArray(data?.findAllUsersById) && data.findAllUsersById.length < 1)
    <Empty text={"No User Found"} />;
  return (
    <Div className="px-4 relative">
      <div className="flex items-center">
        <GoBack />
        <button className="ml-auto">
          <MdNotifications className="text-xl" />
        </button>
      </div>

      <>
        <div className="text-center">
          <p className="text-sm text-gray-300">Wallet Address</p>
          <p className="text-2xl font-bold text-gray-800 dark:text-white">
            1GVY5eZvtc5bA6EFEGnpqJeHUC5YaV5dsb
          </p>
        </div>

        <div className="my-6 grid gap-2">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={undefined}
            trailing={undefined}
          >
            <p className="text-left font-medium">Name</p>
            <p className="text-left">
              {data.findAllUsersById[0].profile.firstName}{" "}
              {data.findAllUsersById[0].profile.lastName}
            </p>
          </ItemsTab>

          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={undefined}
            trailing={undefined}
          >
            <p className="text-left font-medium">Phone Number</p>
            <p className="text-left">08020544017</p>
          </ItemsTab>

          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={undefined}
            trailing={undefined}
          >
            <p className="text-left font-medium">Email</p>
            <p className="text-left">email@email.com</p>
          </ItemsTab>

          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={undefined}
            trailing={undefined}
          >
            <p className="text-left font-medium">Country</p>
            <p className="text-left">Nigeria</p>
          </ItemsTab>
        </div>
      </>
    </Div>
  );
};

export default MinorProfile;
